const ComplianceElements = [
  {
    name: 'Assessing Risk',
    link: 'assessing-risk',
    icon: 'manage_search',
    exec_summ:
      'The percentages presented indicate the distribution of high, medium, and low compliance‑risk activities derived from activities spanning all Assessing Risk domains—ABAC, Promotional Risk, Third‑Party Risk, and Data Management.',
    description:
      'Identifies, evaluates, and prioritizes compliance risks across activities like ABAC, promotional practices, third-party engagement, data privacy, and GxP.',
  },
  {
    name: 'Training & Engagement',
    link: 'training-&amp;-engagement',
    icon: 'diversity_3',
    exec_summ:
      'The percentages presented indicate the distribution of high, medium, and low compliance‑risk activities derived from activities spanning all Training and Engagement domains.',
    description:
      'Develops ethical culture and capability through role-based learning focused on high-risk areas (HCP/government interactions, promotional compliance, patient safety, data protection), tracking completion and effectiveness to drive behaviour change.',
  },
  {
    name: 'Assurance Activities',
    link: 'assurance-activities',
    icon: 'fact_check',
    exec_summ:
      'The percentages presented indicate the distribution of high, medium, and low compliance‑risk activities derived from activities spanning all Assurance Activities domains.',
    description:
      'Tests control design and effectiveness via risk-based monitoring, audits, and testing; validates corrective actions, confirms issue closure, and integrates insights into risk assessments and governance for improvement.',
  },
  {
    name: 'Speak Up & Reporting',
    link: 'speak-up-&amp;-reporting',
    icon: 'campaign',
    exec_summ:
      'The percentages presented indicate the distribution of high, medium, and low compliance‑risk activities derived from activities spanning all Speak Up & Reporting domains.',
    description:
      'Offers confidential, protected channels to report concerns with a non-retaliation policy; ensures timely investigation, documentation, escalation, and promotes transparency and trust.',
  },
  {
    name: 'Standards & Procedures',
    link: 'standards-&amp;-procedures',
    icon: 'assignment',
    exec_summ:
      'The percentages presented indicate the distribution of high, medium, and low compliance‑risk activities derived from activities spanning all Standards & procedures domains.',
    description:
      'Converts laws, codes, and AZ principles into actionable policies and SOPs; clarifies roles and controls like medical-legal review and third-party due diligence for consistent, auditable execution.',
  },
  {
    name: 'Oversight & Control',
    link: 'oversight-&amp;-control',
    icon: 'policy',
    exec_summ:
      'The percentages presented indicate the distribution of high, medium, and low compliance‑risk activities derived from activities spanning all oversight and control domains.',
    description:
      'Provides governance, accountability, and performance management using preventive and detective controls, ownership, committees, and KPIs to manage risk, enforce consequences, and drive ongoing improvement.',
  },
];

export default ComplianceElements;
